import Cookies from 'js-cookie';
import { getCookieDomain } from './cookieDomain';

export interface CouponCookieData {
  code: string;
  bannerText?: string;
}

export function removeCookie(name: string) {
  Cookies.remove(name, { domain: getCookieDomain() });
}

export const COUPON_COOKIE_NAME = 'coupon_data';
export const COUPON_COOKIE_EXPIRATION_HOURS = 72;
